
function objectToQueryString(obj) {
  return Object.entries(obj).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
  ).join('&');
}
export default objectToQueryString;
